export default {
  path: '/subscriptions',
  name: 'subscriptions',
  component: () => import(/* webpackChunkName: "list-view-subscriptions" */ './ListViewSubscriptions'),
  meta: {
    requiresAuth: true
  }
}
